import styled from 'styled-components';

interface INavCards {
  width?: number;
  fontSize?: number;
  opacity?: number;
  iconWidth?: number;
  marginLeft?: number;
  marginRight?: number;
  transition?: boolean;
}

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 26.875rem;
  min-width: 26.875rem;
  align-items: flex-end;
  padding: 0 1.5rem;
  padding-top: 2rem;
  padding-bottom: 2.5rem;
  background: #FFFFFF;
  box-shadow: 0.25rem 0px 1rem rgba(0, 0, 0, 0.04);
  position: relative;
  transition: ease width .3s, ease min-width .3s;
  overflow: auto;
  overflow-x: hidden;
  &.active {
    width: 3.75rem;
    min-width: 3.75rem;
  }
  &::-webkit-scrollbar {
      width: 0;
      background: transparent;
      border-radius: 0.5rem;
  }
  &::-webkit-scrollbar-thumb {
      background: #cecece;
      border-radius: 0.5rem;
  }
  @media (max-width: 840px){
    opacity: 1;
    z-index: 1;
    height: 100%;
    width: 100%;
    position: absolute;
    transition: ease opacity .3s, ease height .3s, ease min-height .3s, ease max-height;
    &.active {
      z-index: -1;
      padding: 0 1.5rem;
      padding-top: 2rem;
      height: 0;
      position: absolute;
      width: 100%;
      opacity: -1;
      transition: z-index .3s, ease opacity .3s, ease height .3s, ease min-height .3s, ease max-height .3s;
    }
  }
`;

export const NavCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NavSubCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 0;
  min-height: 0;
  margin-right: -2.1875rem;
  transition: ease height .3s;
  padding: 1rem 0 0 1rem;
  &.open {
    height: 10.5rem;
  }
  &.full {
    height: 54rem;
  }
`;

export const NavCardsAnchorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 0;
  z-index: -1;
  padding: 0.5rem 0;
  gap: 0.5rem;
  opacity: 0;
  transition:  z-index .3s, ease height .3s, ease opacity .3s;
  &.open {
    transition: z-index 0s, ease height .3s, ease opacity .3s;
    height: 44.5rem;
    opacity: 1;
    z-index: 0;
    padding: 1rem 0;
  }
`;

export const NavCards = styled.div<INavCards>`
  display: flex;
  width: ${({width}) => `${width?`${width}%`:`${100}%`}`};
  border-radius: 0.625rem;
  align-items: center;
  gap: 1.25rem;
  height: 3.75rem;
  min-height: 3.75rem;
  padding: 0 1.25rem;
  cursor: pointer;
  z-index: 0;
  transition: z-index 0s, ease background-color .3s, ease opacity .3s;
  position: relative;
  opacity: ${({opacity}) => opacity? Number(opacity) :''};
  &.active {
    background-color: #2460D710;
    border-radius: 10px;
    &:hover {
      background-color: #2460D710;
    }
  }
  &.disabled {
    cursor: not-allowed;
  }
  &.hide {
    transition: z-index .3s, ease background-color .3s, ease opacity .3s;
    opacity: 0;
    z-index: -1;
  }
  &.hidden {
    opacity: 0;
    z-index: -1;
  }
  &:hover {
    background-color: #E5E5E525;
    .container {
      opacity: 1;
      z-index: 1;
      position: absolute;
      transition: z-index .15s, ease opacity 0.3s;
    }
    .indicator {
      z-index: 1;
    }
  }
`;

export const Lock = styled.img<INavCards>`
  width: ${({iconWidth}) => `${iconWidth? `${iconWidth/16}rem`:''}`};
  margin-left: ${({marginLeft}) => `${marginLeft? `${marginLeft/16}rem`:''}`};
  margin-right: ${({marginRight}) => `${marginRight? `${marginRight/16}rem`:''}`};
`;

export const NavCardsContent = styled.span<INavCards>`
  font-weight: 400;
  font-size: ${({fontSize}) => `${fontSize?`${fontSize/16}rem`:`${1.5}rem`}`};
  line-height: 1.75rem;
  color: #272848;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const MainArrowContainer = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  position: absolute;
  left: 25.9375rem;
  top: 14.125rem;
  background-color: #FFFFFF;
  box-shadow: 0.125rem 0.125rem 1rem rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: left .3s 0s, ease background-color .3s, ease filter .3s;
  &:hover {
    background-color: #2460D7;
    .main {
      filter: invert(99%) sepia(18%) saturate(2%) hue-rotate(312deg) brightness(115%) contrast(100%);
    }
  }
  &.move {
    left: 2.5rem;
    top: 14.125rem;
  }
  @media (max-width: 840px){
    display: none;
  }
`;

export const Arrow = styled.img<INavCards>`
  margin-top: 0.375rem;
  width: 1.125rem;
  transition: ${({transition}) => `${transition? '':'ease transform .3s'}`};
  &.flip {
    transform: rotate(180deg);
  }
  &.flip-only {
    transform: rotate(0deg);
  }
  &.main {
    margin-top: 0;
    margin-right: 2px;
    margin-left: 0.125rem;
    transform: rotate(90deg);
    &.flip {
      margin-left: 5px;
      transform: rotate(270deg);
    }
  }
`;

export const ToolTipIndicator = styled.div`
  background-color: #272848;
  position: absolute;
  z-index: -1;
  top: -5px;
  width: 16px;
  height: 16px;
  transform: rotate(45deg);
`;

export const ToolTipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  bottom: -36px;
  width: 8.625rem;
  height: 3rem;
  background-color: #272848;
  color: #FFFFFF;
  position: absolute;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.875rem;
  opacity: 0;
  z-index: -1;
  border-radius: 16px;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.125rem;
  color: #FFFFFF;
  left: 80px;
  top: 56px;
  transition: z-index .3s, ease opacity 0.3s;
`;